import { api, auth } from '@/f1/service';
import codes from '@/f1/codes';
import { Switch as cSwitch } from '@coreui/vue';
import Language from './language';
// import agent from '../../agent/service'

const _i18n_data = {
  saved: {
    EN : `saved`,
    KO : `저장되었습니다`,
  },
  updated: {
    EN : `updated`,
    KO : `업데이트되었습니다`,
  },
  removed: {
    EN : `removed`,
    KO : `삭제되었습니다`,
  },
};

export default {
  components: { cSwitch, Language },
  computed: { i18n_data() { return _i18n_data; } }, // i18n 메세지 변환용.
  data : () => {
    return {
      apply_alive : 0,
      modal_save : false,
      is_test : false,
      auth,
      codes,
      confirm: false,
      add: false,
      lock: true,
      model : {},
      status : {},
      pattern_test : []
    }
  },
  methods: {
    is_valid() {
      if(!(this.model.type || '')) {  this.$toastr.e('type are required'); return false; }
      if(!(this.model.ext || '')) {  this.$toastr.e('ext are required'); return false; }
      if(!(this.model.category || '')) {  this.$toastr.e('category are required'); return false; }
      if(!(this.model.code || '')) {  this.$toastr.e('code are required'); return false; }
      if(this.model.is_alive == undefined) {  this.$toastr.e('is_alive are required'); return false; }

      // vaildate RegExp (Task #1921)
      if(this.model.type == '1') { // 1 = Regex
        let pattern = '/' + this.model.code + '/';
        let flag = '';
        let re = (function(o, p, f) {
          try { return new RegExp(p, f); }
          catch(e) { return o.$toastr.e(e.message); }
        })(this, pattern, flag);

        if(re instanceof RegExp) {
          this.$toastr.s("Vaild expression: " + pattern);
        } else {
          this.$toastr.e("No vaild expression");
          return false
        }
      }
      return true
    },
    async test() {
      if(!this.is_valid()) { return }
      try {

        // 강제 미사용 적용
        this.model.is_alive = false
        // 모달 닫기
        this.modal_save = false

        let rs = await api.wsfinder.WSFinder_Call('pattern', 'test', this.model)
        if(rs.error) { return this.$toastr.e("load failed") }
        console.log(rs.body)
        if(rs.body.alive && rs.body.alive > 0) {
          // 점검 요청하였으며 곧 안내됩니다
          this.$toastr.s('request testing');
          this.is_test = true
          this.apply_alive = rs.body.alive
          this.apply_request = rs.body.request
          this.$parent.$emit('refresh')
        } else {
          // rs.body.count
          return this.$toastr.e("no have online agent ")
        }

        // 전송 완료한 에이전트 목록을 줘야 함, 여기서 에이전트 미리 영향도 테스트는 강제 해야 한다
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) ; }
    },
    cancel: function() {
      if(this.add) { return this.list() }
      this.lock = true
    },
    list: function() { this.$router.push({ name: 'wsfinder_pattern'}); this.$parent.$emit('refresh') },
    async save() {
      // 모달 닫기
      this.modal_save = false

      if(!this.is_valid()) { return }

      try {
        // this.model.is_alive = true
        let rs = await api.wsfinder.WSFinder_Call('pattern', this.model.id ? 'update' : 'insert', this.model)
        if(rs.error) { return this.$toastr.e("load failed") }

        this.$toastr.s(this.i18n_data['saved'][this.i18n]);
        this.$parent.$emit('refresh');
        this.list();

        // return;
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) ; }
    },
    async response_handler(m) {

      if(m.cmd != 'pattern.test' && m.cmd != 'status') { return }

      let pl = m.body;

      console.log(m.cmd, pl, m)
      // switch (m.cmd) {
      //   case 'status':
      //     this.status[m.agent_id] = Object.assign({}, this.status[m.agent_id], JSON.parse(pl))
      //     break;
      //     case 'pattern.test':
      //     this.pattern_test.push(pl)
      //     break;

      //   default:
      //     break;
      // }
    },
    // list() { this.$router.push({ name: 'wsfinder_pattern'}); },
    edit() { this.lock = false },
    async remove() {
      try{
        await api.wsfinder.WSFinder_Call('pattern', 'delete', { id : this.model.id})
        this.$emit('refresh'); this.$toastr.s(this.i18n_data['removed'][this.i18n]); this.list();
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
    },
    async get(id = this.$route.params.id) {
      console.log('pattern.detail.vue', 'load item', id);
      this.lock = true
      if(id == 'add') { this.lock = false; this.add = true; return }
      try {
        let rs = await api.wsfinder.WSFinder_Call('pattern', 'detail', { id : id})

        this.model = Object.assign({}, this.model, rs.body)
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params.id); console.log(from.path) } },
  created: function() {   console.log('pattern.detail.vue', 'created'); },
  destroyed: function() {
    console.log('pattern.detail.vue', 'destroyed');
    // signalr.subscribe('wsfinder', this.response_handler);
  },
  mounted: function() {
    console.log('pattern.detail.vue', 'mounted');
    this.get(this.$route.params.id);
    // signalr.subscribe('wsfinder', this.response_handler);
  },
}
